import { IconDirectorChair } from '../icons'

/**
 * Shared identity indicators for Director's Cut screens.
 *
 * <DCDirectorBanner /> — gold banner shown at the top of every DC screen on
 *                        the Director's own phone. IconDirectorChair + label.
 * <DCHostDirectorLine /> — "Director · {name}" pill shown on every DC screen
 *                          on the host TV. Same IconDirectorChair, pill chrome.
 *
 * Drop these at the top of each DC role-branch (director / host) to keep the
 * identity context persistent across every phase of the mode.
 */

export function DCDirectorBanner() {
  return (
    <div className="dc-director-banner" aria-live="polite">
      <IconDirectorChair size={16} aria-hidden="true" />
      <span>You are the Director</span>
    </div>
  )
}

export function DCHostDirectorLine({ party }) {
  const directorUid = party?.directorUid
  const director = directorUid ? party?.players?.[directorUid] : null
  if (!director) return null
  return (
    <div className="dc-director-pill">
      <IconDirectorChair size={14} aria-hidden="true" />
      <span>Director · <strong>{director.username || 'Guest'}</strong></span>
    </div>
  )
}
